// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1q6at85-MuiInputBase-root-MuiOutlinedInput-root {
  height: 5vh;
  width: 244px;
}

.MuiGrid-root .MuiGrid-item .MuiGrid-grid-md-8 .css-am41oj-MuiGrid-root canvas {
  height: 284px;
  width: 731px;
}

.policies-container {
  width: 82%;
  margin-left: 18%;
  min-width: 0;
  box-sizing: border-box;
}
@media (max-width: 1024px) {
  .policies-container {
    width: 72%;
    margin-left: 28%;
  }
}
@media (max-width: 600px) {
  .policies-container {
    width: calc(100% - 180px);
    margin-left: 180px;
  }
}

.details-heading {
  text-align: left;
  font-size: 14px !important;
  color: #003478;
  font-weight: 600 !important;
  margin-top: 8px !important;
}

.approve-policy-page {
  margin-top: 10px;
  width: 82%;
  margin-left: 18%;
  height: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 20px 20px 16px;
  overflow: hidden;
}
@media (max-width: 1024px) {
  .approve-policy-page {
    width: 72%;
    margin-left: 28%;
  }
}
@media (max-width: 600px) {
  .approve-policy-page {
    width: calc(100% - 180px);
    margin-left: 180px;
    padding: 10px;
  }
}

.approve-policy-top {
  width: 100%;
  flex-shrink: 0;
  margin-bottom: 10px;
}

.approve-policy-progress {
  width: min(280px, 100%);
  min-width: 0;
}

.approve-policy-scroll {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  overflow: auto;
}

.approve-policy {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 20px 24px 24px;
}

.policy-field-row {
  width: 100% !important;
  height: auto !important;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap !important;
  align-items: flex-start;
  gap: 16px 20px;
  box-sizing: border-box;
}

.approve-policy-actions {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 40px;
  height: auto !important;
}

.approve-policy-actions .MuiButton-root {
  width: min(186px, 100%) !important;
  max-width: 100%;
}

.approve-policy .Policy-textfield {
  flex: 1 1 220px;
  width: min(100%, 280px);
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.approve-policy .Policy-textfield > div,
.approve-policy .Policy-textfield .MuiTextField-root,
.approve-policy .Policy-textfield .MuiFormControl-root,
.approve-policy .Policy-textfield .MuiInputBase-root,
.approve-policy .Policy-textfield .MuiOutlinedInput-root,
.approve-policy .Policy-textfield .MuiPickersTextField-root,
.approve-policy .Policy-textfield .MuiPickersInputBase-root {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  min-height: 40px;
  height: auto !important;
  background-color: #fff;
  box-sizing: border-box;
}

.approve-policy-top .MuiButton-root {
  width: min(245px, 100%) !important;
  max-width: 100%;
}

.Policy-textfield .input-label {
  font-size: 14px;
}
.Policy-textfield .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
  width: 200px;
  background-color: white;
}
.Policy-textfield .css-1v4ccyo {
  width: 200px;
  background-color: white;
}
.Policy-textfield .css-1x5jdmq {
  height: 0px !important;
}
.Policy-textfield .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  height: 0px !important;
}

.policyDetails .css-ahj2mt-MuiTypography-root {
  color: black;
  text-align: center;
  margin-top: 10px;
}

.css-14x1nlk {
  transform: translate(12px, 7px) scale(0.75) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Policies/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;AACJ;;AAQgB;EACI,aAAA;EACA,YAAA;AALpB;;AAYA;EACI,UAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;AATJ;AAWI;EANJ;IAOQ,UAAA;IACA,gBAAA;EARN;AACF;AAUI;EAXJ;IAYQ,yBAAA;IACA,kBAAA;EAPN;AACF;;AAiBA;EACI,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;AAdJ;;AAiBA;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAdJ;AAgBI;EAVJ;IAWQ,UAAA;IACA,gBAAA;EAbN;AACF;AAeI;EAfJ;IAgBQ,yBAAA;IACA,kBAAA;IACA,aAAA;EAZN;AACF;;AAeA;EACI,WAAA;EACA,cAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,uBAAA;EACA,YAAA;AAZJ;;AAeA;EACI,SAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AAZJ;;AAeA;EACI,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;AAZJ;;AAeA;EACI,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AAZJ;;AAeA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAZJ;;AAeA;EACI,kCAAA;EACA,eAAA;AAZJ;;AAeA;EACI,eAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAZJ;;AAeA;;;;;;;EAOI,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;AAZJ;;AAeA;EACI,kCAAA;EACA,eAAA;AAZJ;;AAgBI;EACI,eAAA;AAbR;AAeI;EACI,YAAA;EACA,uBAAA;AAbR;AAeI;EACI,YAAA;EACA,uBAAA;AAbR;AAeI;EACI,sBAAA;AAbR;AAeI;EACI,sBAAA;AAbR;;AAkBI;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;AAfR;;AAmBA;EACI,sDAAA;AAhBJ","sourcesContent":[".css-1q6at85-MuiInputBase-root-MuiOutlinedInput-root {\r\n    height: 5vh;\r\n    width: 244px;\r\n}\r\n\r\n\r\n\r\n.MuiGrid-root {\r\n    .MuiGrid-item {\r\n        .MuiGrid-grid-md-8 {\r\n            .css-am41oj-MuiGrid-root {\r\n                canvas {\r\n                    height: 284px;\r\n                    width: 731px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.policies-container{\r\n    width: calc(100% - 18%);\r\n    margin-left: 18%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n\r\n    @media (max-width:1024px) {\r\n        width: calc(100% - 28%);\r\n        margin-left: 28%;\r\n    }\r\n\r\n    @media (max-width: 600px) {\r\n        width: calc(100% - 180px);\r\n        margin-left: 180px;\r\n    }\r\n}\r\n\r\n// .input-label{\r\n//     display:block;\r\n// }\r\n// .text-field{\r\n//     width:30%;\r\n//     height:30px;\r\n// }\r\n.details-heading{\r\n    text-align:left;\r\n    font-size:14px !important;\r\n    color:#003478;\r\n    font-weight: 600 !important;\r\n    margin-top: 8px !important;\r\n}\r\n\r\n.approve-policy-page {\r\n    margin-top: 10px;\r\n    width: calc(100% - 18%);\r\n    margin-left: 18%;\r\n    height: 100%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n    padding: 20px 20px 16px;\r\n    overflow: hidden;\r\n\r\n    @media (max-width: 1024px) {\r\n        width: calc(100% - 28%);\r\n        margin-left: 28%;\r\n    }\r\n\r\n    @media (max-width: 600px) {\r\n        width: calc(100% - 180px);\r\n        margin-left: 180px;\r\n        padding: 10px;\r\n    }\r\n}\r\n\r\n.approve-policy-top {\r\n    width: 100%;\r\n    flex-shrink: 0;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.approve-policy-progress {\r\n    width: min(280px, 100%);\r\n    min-width: 0;\r\n}\r\n\r\n.approve-policy-scroll {\r\n    flex: 1;\r\n    min-height: 0;\r\n    width: 100%;\r\n    overflow: auto;\r\n}\r\n\r\n.approve-policy {\r\n    margin-top: 20px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    background-color: #f2f2f2;\r\n    border-radius: 10px;\r\n    padding: 20px 24px 24px;\r\n}\r\n\r\n.policy-field-row {\r\n    width: 100% !important;\r\n    height: auto !important;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap !important;\r\n    align-items: flex-start;\r\n    gap: 16px 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.approve-policy-actions {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n    margin-top: 40px;\r\n    height: auto !important;\r\n}\r\n\r\n.approve-policy-actions .MuiButton-root {\r\n    width: min(186px, 100%) !important;\r\n    max-width: 100%;\r\n}\r\n\r\n.approve-policy .Policy-textfield {\r\n    flex: 1 1 220px;\r\n    width: min(100%, 280px);\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.approve-policy .Policy-textfield > div,\r\n.approve-policy .Policy-textfield .MuiTextField-root,\r\n.approve-policy .Policy-textfield .MuiFormControl-root,\r\n.approve-policy .Policy-textfield .MuiInputBase-root,\r\n.approve-policy .Policy-textfield .MuiOutlinedInput-root,\r\n.approve-policy .Policy-textfield .MuiPickersTextField-root,\r\n.approve-policy .Policy-textfield .MuiPickersInputBase-root {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    min-width: 0 !important;\r\n    min-height: 40px;\r\n    height: auto !important;\r\n    background-color: #fff;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.approve-policy-top .MuiButton-root {\r\n    width: min(245px, 100%) !important;\r\n    max-width: 100%;\r\n}\r\n\r\n.Policy-textfield{\r\n    .input-label{\r\n        font-size: 14px;\r\n    }\r\n    .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root{\r\n        width:200px;\r\n        background-color:white\r\n    }\r\n    .css-1v4ccyo{\r\n        width:200px;\r\n        background-color:white\r\n    }\r\n    .css-1x5jdmq{\r\n        height: 0px !important;\r\n    }\r\n    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\r\n        height: 0px !important;\r\n    }\r\n}\r\n\r\n.policyDetails{\r\n    .css-ahj2mt-MuiTypography-root{\r\n        color:black;\r\n        text-align: center;\r\n        margin-top: 10px;\r\n    }\r\n}\r\n\r\n.css-14x1nlk {\r\n    transform: translate(12px, 7px) scale(0.75) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
